import { ActionCell } from '../columns';

export const OAUTH_STATUS = {
  ACTIVE: 'active',
  RGP: 'rgp',
  EXPIRED: 'expired',
};

export const getOAuthStatus = (status) => {
  const dictionary = {
    [OAUTH_STATUS.ACTIVE]: {
      label: (t) => t('Active'),
      statusColor: 'var(--color-viz-cat-1-primary)',
    },
    [OAUTH_STATUS.RGP]: {
      label: (t) => t('RGP?'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    },
    [OAUTH_STATUS.EXPIRED]: {
      label: (t) => t('Expired'),
      statusColor: 'var(--color-viz-cat-3-primary)',
    },
  };
  return dictionary[status];
};

export const OAuthActionCell = ({ t, ...props }) => {
  return (
    <ActionCell
      options={[{ value: 'onTokenRevoke', label: t('Revoke') }]}
      t={t}
      title={t('Revoke')}
      {...props}
    />
  );
};
